var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('user-form',{attrs:{"user":this.user,"roles":this.roles,"teams":this.teams,"accounts":this.accounts,"isSuperAdmin":this.isSuperAdmin,"isAdmin":this.isAdmin,"editUser":false},on:{"formSubmit":_vm.createUser,"formReset":_vm.resetForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b0c5a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/newUser.vue
// module id = 1225
// module chunks = 1